import React, { useEffect, useRef, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import { getAuth, signInWithCustomToken } from "firebase/auth/web-extension";
import {
  collection,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { receive } from "./messages";
import Dialog from "./dialog/Dialog";
import "../assets/receive.scss";
import Text from "./text/Text";
import { QRCodeComponent } from "./qrCode/QRCodeComponent";
import Clipboard from "./clipboard/Clipboard";
import {
  getAccountFees,
  getFirebaseTokenForAccount,
  // handleCopy,
  // handleDownload,
  lightningLabel,
} from "./constants";
import CommonSkeleton from "./CommonSkeleton";
import { useSession } from "../hooks/useSession";
import WalletSymbols from "./WalletSymbols";
import TruncatedTextTooltip from "./TruncatedTextTooltip";
import { app } from "../util/firebase";
import SpeedFeeComponent from "./SpeedFeeComponent";
let unsubscribe;

function LnAddressQrModal({
  isModalOpen,
  setIsModalOpen,
  isFromBrowser,
  lnAddress,
}) {
  const fontSize = isFromBrowser ? 16 : 14;
  const [selectedActionId, setSelectedActionId] = useState(null);
  const [copy, setCopy] = useState(false);
  const [accountFees, setAccountFees] = useState(0);
  const [fixedFee, setFixedFee] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);

  const address = lnAddress?.address;
  const { session } = useSession();
  const qrRef = useRef();

  const open = Boolean(anchorEl);

  const navigate = useNavigate();
  const accountId = session?.account?.account?.id;
  const { taprootAsset, walletCurrency } = useSelector((state) => state.common);
  const { uuid: currency } = { ...taprootAsset };

  const actionsArray = [
    {
      id: "copyQrCode",
      icon: <WalletSymbols customClass="actions-icon" symbol="qr_code" />,
      text: "Copy QR Code",
    },
    {
      id: "copyInvoice",
      icon: <WalletSymbols customClass="actions-icon" symbol="receipt" />,
      text: "Copy LN Address",
    },
    {
      id: "downloadQR",
      icon: <WalletSymbols customClass="actions-icon" symbol="download" />,
      text: "Download QR",
    },
  ];

  useEffect(() => {
    fetchAccountFees();
  }, []);

  useEffect(() => {
    session && fetchPayment();
  }, [session]);

  const fetchAccountFees = async () => {
    try {
      const speedFee = await getAccountFees(lightningLabel, currency, "01");
      setAccountFees(speedFee.feePercentage);
      setFixedFee(speedFee.fixedFee);
    } catch (err) {}
  };

  const displayQR = () => {
    return (
      <QRCodeComponent
        value={address}
        size={isFromBrowser ? 322 : 223}
        icon
        iconSize={25}
        level={"H"}
        qrRef={qrRef}
      />
    );
  };

  const handleAction = (id) => {
    const newRef = qrRef;

    setSelectedActionId(id);
    if (id === "copyQrCode") {
      // handleCopy(newRef, setCopy);
    }
    if (id === "downloadQR") {
      // handleDownload(newRef, address);
    }

    if (id === "copyInvoice") {
      const text = address;

      navigator.clipboard.writeText(text);
      setCopy(true);
      setTimeout(() => {
        setCopy(false);
      }, 3000);
    }
  };

  const getPaymentData = async (paymentId) => {
    const db = getFirestore(app);

    const paymentDataQuery = query(
      collection(db, "account", accountId, "payments"),
      where("modified", ">", new Date().getTime())
    );

    try {
      unsubscribe = onSnapshot(paymentDataQuery, async (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data();

          if (data) {
            if (data?.status?.toLowerCase() === "paid") {
              navigate("/success-page", {
                state: { details: data, type: "payment" },
              });
              unsubscribe();
            }
          }
        });
      });
    } catch (error) {}
  };

  const fetchPayment = async () => {
    const token = await getFirebaseTokenForAccount();
    const authObj = getAuth(app);
    token?.firebase_token &&
      signInWithCustomToken(authObj, token?.firebase_token)
        .then(() => {
          getPaymentData();
        })
        .catch((_error) => {});
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <Box>
      <Dialog
        isOpenModal={isModalOpen}
        setIsOpenModal={setIsModalOpen}
        modalHeader={receive}
        directionToOpen={isFromBrowser ? "up" : "left"}
        handleAction={() => setIsModalOpen(false)}
        isShowCloseIcon={isFromBrowser}
      >
        <Box
          className={isFromBrowser && "options-modal-container"}
          height={isFromBrowser ? "auto" : "100%"}
        >
          <Box className="lightning-receive-container">
            <Box className="qr-code-section">
              <Box className="lightning-header">
                <Text className="default-text" size={16} font="semibold">
                  {session?.user?.first_name + " " + session?.user?.last_name}
                </Text>
              </Box>

              <Box p="0px 36px 20px">
                {displayQR()}
                <Box className="ln-address">
                  <TruncatedTextTooltip
                    textProps={{
                      className: "default-text ",
                      font: "regular",
                      color: "#2A67FF !important",
                    }}
                    textValue={address}
                    cellWidth={isFromBrowser ? "385px" : "175px"}
                    fontSize={fontSize}
                  />
                  <Clipboard text={address} height="16px" width="16px" />
                </Box>
                <SpeedFeeComponent
                  isFromBrowser={isFromBrowser}
                  speedFee={accountFees}
                  fixedFee={fixedFee}
                />
              </Box>
            </Box>
            <Box className="qr-actions" mt="20px">
              <Box
                className={`action-section ${
                  !isFromBrowser ? "popup-action" : ""
                }`}
              >
                {actionsArray.map((feature) => {
                  return (
                    <Tooltip
                      title="Copied to clipboard"
                      placement="top-start"
                      open={selectedActionId === feature?.id && copy}
                      key={feature?.id}
                    >
                      <Box
                        className="actions"
                        onClick={() => handleAction(feature?.id)}
                      >
                        {false ? (
                          <>
                            <CommonSkeleton
                              variant="circle"
                              height={isFromBrowser ? "60px" : "50px"}
                              width={isFromBrowser ? "60px" : "50px"}
                              sx={{ marginRight: "30px" }}
                            />
                            <CommonSkeleton
                              width={isFromBrowser ? "60px" : "50px"}
                            />
                          </>
                        ) : (
                          <>
                            {feature.icon}
                            <Text
                              className="default-text"
                              size={isFromBrowser ? 14 : 12}
                              font="semibold"
                            >
                              {feature.text}
                            </Text>
                          </>
                        )}
                      </Box>
                    </Tooltip>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}

export default LnAddressQrModal;
